// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/Icon'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

// loads the Icon plugin
UIkit.use(Icons);

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


jQuery(document).ready(function($){

  $('a').each(function(){
    if ( $(this).attr('target') == '_blank' ) {
      $(this).attr('rel', 'noopener');
    }
  });
	$('a[href$=".gif"], a[href$=".jpg"], a[href$=".png"], a[href$=".bmp"]').each(function(){
    $(this).wrap('<div data-uk-lightbox="animation:scale"></div>');
	})

  $('a img').each(function(){
    $(this).parent().addClass('image-link');

    if ( $(this).hasClass('alignright') ) {
      $(this).parent().addClass('alignright');
    } else if ( $(this).hasClass('alignleft') ) {
      $(this).parent().addClass('alignleft');
    } else if ( $(this).hasClass('aligncenter') ) {
      $(this).parent().addClass('aligncenter');
    }
  });

  $('a.uk-button').each(function(){
    $(this).html('<span>'+$(this).html()+'</span>');
  });

  if ( $('.gform_previous_button').length > 0 ) {
    $('.gform_previous_button').addClass('uk-button gray');
  }

  $('#fb-share').click(function() {
    var the_url = $(this).attr('data-url');
    popupCenter('https://www.facebook.com/sharer/sharer.php?u='+the_url, 'pop', '600', '400');
    return false;
  });
  $('#twitter-share').click(function() {
    var the_url = $(this).attr('data-url');
    var the_title = $(this).attr('data-title');
    popupCenter('http://twitter.com/home?status='+the_title+' '+the_url, 'pop', '600', '400');
    return false;
  });
  $('#linkedin-share').click(function() {
    var the_url = $(this).attr('data-url');
    var the_title = $(this).attr('data-title');
    popupCenter('http://www.linkedin.com/shareArticle?mini=true&url='+the_url+'&title='+the_title, 'pop', '600', '400');
    return false;
  });
  $('#pinterest-share').click(function() {
    var the_url = $(this).attr('data-url');
    var the_title = $(this).attr('data-title');
    popupCenter('http://pinterest.com/pin/create/link/?url='+the_url+'&is_video=false&description='+the_title, 'pop', '600', '400');
    return false;
  });

  /* if ( $('.core-values-alt').length > 0 ) {
    $('.values li').connections({to: '.title'});
  } */

});

function popupCenter(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}

var BrowserDetect = {
  init: function () {
      this.browser = this.searchString(this.dataBrowser) || 'Other';
      this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || 'Unknown';
  },
  searchString: function (data) {
      for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          this.versionSearchString = data[i].subString;

          if (dataString.indexOf(data[i].subString) !== -1) {
              return data[i].identity;
          }
      }
  },
  searchVersion: function (dataString) {
      var index = dataString.indexOf(this.versionSearchString);
      if (index === -1) {
          return;
      }

      var rv = dataString.indexOf('rv:');
      if (this.versionSearchString === 'Trident' && rv !== -1) {
          return parseFloat(dataString.substring(rv + 3));
      } else {
          return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
      }
  },

  dataBrowser: [
      {string: navigator.userAgent, subString: 'Edge', identity: 'MS Edge'},
      {string: navigator.userAgent, subString: 'MSIE', identity: 'Explorer'},
      {string: navigator.userAgent, subString: 'Trident', identity: 'Explorer'},
      {string: navigator.userAgent, subString: 'Firefox', identity: 'Firefox'},
      {string: navigator.userAgent, subString: 'Opera', identity: 'Opera'},
      {string: navigator.userAgent, subString: 'OPR', identity: 'Opera'},
      {string: navigator.userAgent, subString: 'Chrome', identity: 'Chrome'},
      {string: navigator.userAgent, subString: 'Safari', identity: 'Safari'},
  ],
};

BrowserDetect.init();
//document.write('You are using <b>' + BrowserDetect.browser + '</b> with version <b>' + BrowserDetect.version + '</b>');

var bv= BrowserDetect.browser;
if( bv == 'Chrome'){
  $('body').addClass('chrome');
}
else if(bv == 'MS Edge'){
  $('body').addClass('edge');
}
else if(bv == 'Explorer'){
  $('body').addClass('ie');
}
else if(bv == 'Firefox'){
  $('body').addClass('Firefox');
}

// Default link styling!

/*
var anchors = document.querySelectorAll('.uk-container a');
var inner = 'innerText' in document.createElement('div') ? 'innerText' : 'textContent';
console.log('HELLO');

for(var i=0;i<anchors.length;i++){
  var a = anchors[i],
      text = a[inner];
  a.innerHTML = '<span class="frank">'+text[0]+'<div class="borders"></div></span>'+text.substr(1,text.length-2)+'<span class="loki">'+text[text.length-1]+'<div class="borders"></div></span>';

  var rect = a.getBoundingClientRect(),
      f = a.querySelector('.frank'),
      start = f.getBoundingClientRect(),
      div1 = f.querySelector('.borders');
  div1.style.width = (rect.right - start.left)+'px';

  if(rect.left < start.left){
      var l = a.querySelector('.loki'),
          end = a.querySelector('.loki').getBoundingClientRect(),
          div2 = l.querySelector('.borders');
      div2.style.width = (end.right-rect.left)+'px';
  }

  a.onmouseover = function() {
    $('.loki .borders').toggleClass('hover', true);
    $('.frank .borders').toggleClass('hover', true);
  }

  a.onmouseout = function(){
    $('.loki .borders').toggleClass('hover', false);
    $('.frank .borders').toggleClass('hover', false);
  }
}
*/



// WEBPACK FOOTER //
// ./scripts/main.js